import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faServer, faTimes } from "@fortawesome/free-solid-svg-icons";
import LinkButton from "./LinkButton";

export const Error = ({ location }) => {
  return (
    <div className="bg-white relative w-full flex justify-center flex-1">
      <div className="container flex flex-col gap-8 px-4 py-12 self-center">
        <div className="w-full flex flex-col gap-4 text-center">
          <div className="background-error-icon">
            <FontAwesomeIcon icon={faServer} />
            <span style={{ fontSize: "3rem", marginLeft: "1rem" }}>
              <FontAwesomeIcon icon={faTimes} />
            </span>
          </div>
          <h1 className="text-3xl text-green-primary font-extra-bold"> Oops...</h1>
          <h2 className="text-xl font-bold text-red">Ocurrió un problema en el servidor.</h2>

          <p>Por favor intenta más tarde</p>
          <LinkButton to="/" className="self-center">
            Regresar a la página principal
          </LinkButton>
          <p>{location.state ? `${location.state.endpoint} code ${location.state.status}` : null}</p>
        </div>
      </div>
    </div>
  );
};
